import { useAtom } from 'jotai';
import { isSidePanelStepOpenAtom } from '../../../../atoms';

export const useSidePanelStep = () => {
  const [isSidePanelStepOpen, setIsOpen] = useAtom(isSidePanelStepOpenAtom);

  const openSidePanelStep = () => {
    setIsOpen(true);
  };

  const closeSidePanelStep = () => {
    setIsOpen(false);
  };

  const toggleSidePanelStep = () => {
    setIsOpen((prevState) => !prevState);
  };

  return {
    isSidePanelStepOpen,
    openSidePanelStep,
    closeSidePanelStep,
    toggleSidePanelStep,
  };
};
